import React from 'react';
import { Alert, Box, Divider, Stack, Typography } from '@mui/material';

function packageLabel(value) {
  if (value === 'OWN_PACKAGE') return 'Own package';
  if (value === 'PARCEL') return 'Parcel';
  return 'Letter';
}

export default function RuleDecisionPanel({ decision }) {
  if (!decision) return null;
  const contents = decision.physical_card_count == null
    ? `${decision.verification_sale_unit_count || 0} sale unit(s) · contents confirmed during Verify`
    : `${decision.physical_card_count} physical cards`;
  const selectionSource = decision.shipping_selection_source === 'OPERATOR_OVERRIDE' ? 'Operator override' : 'Automatic rule';
  return <Stack spacing={1.25}>
    <Box>
      <Typography variant="caption" color="text.secondary">Current decision</Typography>
      <Typography variant="h6" sx={{ fontWeight: 800 }}>{decision.tracking_required ? 'Tracked' : 'Untracked'} · {packageLabel(decision.package_type)}{decision.untracked_stamp_baseline != null ? ` · ${decision.untracked_stamp_baseline} stamp${decision.untracked_stamp_baseline === 1 ? '' : 's'}` : ''}</Typography>
      <Typography variant="body2" color="text.secondary">{selectionSource} · policy {decision.rule_version}</Typography>
    </Box>
    <Typography variant="body2" sx={{ fontWeight: 650 }}>{decision.packaging}</Typography>
    <Divider />
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 1 }}>
      <Box><Typography variant="caption" color="text.secondary">Buyer service</Typography><Typography variant="body2">{decision.buyer_selected_service || 'Unknown'}</Typography></Box>
      <Box><Typography variant="caption" color="text.secondary">Effective service</Typography><Typography variant="body2">{decision.effective_service}</Typography></Box>
      <Box><Typography variant="caption" color="text.secondary">Order goods</Typography><Typography variant="body2">AUD {decision.goods_value}</Typography></Box>
      <Box><Typography variant="caption" color="text.secondary">Contents basis</Typography><Typography variant="body2">{contents}</Typography></Box>
      <Box><Typography variant="caption" color="text.secondary">Insurance estimate</Typography><Typography variant="body2">AUD {decision.insurance_policy_estimate_aud}</Typography></Box>
      <Box><Typography variant="caption" color="text.secondary">Signature</Typography><Typography variant="body2">{decision.signature_required ? 'Required' : 'Not required by policy'}</Typography></Box>
    </Box>
    <Typography variant="caption" color="text.secondary">Rule basis: {decision.shipping_rule_basis || 'legacy policy'} · Confirm actual physical fit and postage/service requirements during Prepare. This is not a carrier quote.</Typography>
    {decision.reasons?.length > 0 && <Typography variant="caption" component="div">Reasons: {decision.reasons.join(', ')}</Typography>}
    {decision.issues?.map((code) => <Alert key={code} severity="warning" sx={{ py: 0.25 }}>{code}</Alert>)}
  </Stack>;
}
